import { Input, KeyCode } from "../../lib/Input";
import SPAbility from "../SPAbility";
import SPHealingFieldBehavior from "../SPHealingFieldBehavior";
import SPPlayer from "../SPPlayer";

export class SPHealZone extends SPAbility {

    constructor(player: SPPlayer) {
        super(player, {
            cooldown: 60,
            duration: 3,
            icon: 12,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyDown
        });
    }

    onUse(): void {
        this.player.engine.NewGameObjectWithScript(SPHealingFieldBehavior, {
            position: this.player.transform.position
        });
    }

}